import { useState } from 'react';
import { Link } from 'react-router-dom';
import './Contact.css';

export default function Contact() {
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
  };

  return (
    <>
      <div className="page-banner">
        <h1>Contact Us</h1>
        <p>We'd love to hear from you</p>
        <nav className="breadcrumb">
          <Link to="/">Home</Link>
          <span>/</span>
          <span>Contact</span>
        </nav>
      </div>

      <section className="contact-section">
        <div className="container contact-grid">
          <div className="contact-info-col">
            <p className="section-label">Get In Touch</p>
            <h2 className="section-title">For Prayer Request <span>& Query</span></h2>
            <p className="ci-intro">
              Whether you need prayer, want to partner as a church, or simply want to know more about
              our mission — reach out. We are here to serve.
            </p>

            <div className="ci-cards">
              <div className="ci-card">
                <div className="ci-icon">📍</div>
                <div>
                  <h4>Our Location</h4>
                  <p>2240 Kipling Avenue<br />Toronto, Ontario, Canada</p>
                </div>
              </div>
              <div className="ci-card">
                <div className="ci-icon">📞</div>
                <div>
                  <h4>Phone</h4>
                  <p><a href="tel:+14168579811">+1-416-857-9811</a></p>
                </div>
              </div>
              <div className="ci-card">
                <div className="ci-icon">✉</div>
                <div>
                  <h4>Email</h4>
                  <p><a href="mailto:nbirthcci@gmail.com">nbirthcci@gmail.com</a></p>
                </div>
              </div>
              <div className="ci-card">
                <div className="ci-icon">🕐</div>
                <div>
                  <h4>Office Hours</h4>
                  <p>Monday – Friday<br />8:00 AM – 9:00 PM</p>
                </div>
              </div>
            </div>

            <div className="ci-social">
              <h4>Follow Us</h4>
              <div className="social-row">
                {['Twitter', 'Facebook', 'YouTube', 'Instagram'].map(s => (
                  <a key={s} href="https://facebook.com" target="_blank" rel="noreferrer" className="social-chip">
                    {s}
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="contact-form-col">
            {sent ? (
              <div className="form-success">
                <div className="success-icon">✅</div>
                <h3>Message Sent!</h3>
                <p>Thank you for reaching out. We will get back to you as soon as possible.</p>
                <button className="btn-primary-gold" onClick={() => setSent(false)} style={{ marginTop: '1.5rem' }}>
                  Send Another
                </button>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <h3 className="form-title">Send Us a Message</h3>
                <div className="form-row-two">
                  <div className="form-group">
                    <label>Full Name *</label>
                    <input type="text" placeholder="Your full name" required />
                  </div>
                  <div className="form-group">
                    <label>Email Address *</label>
                    <input type="email" placeholder="your@email.com" required />
                  </div>
                </div>
                <div className="form-group">
                  <label>Phone Number</label>
                  <input type="tel" placeholder="+1 (000) 000-0000" />
                </div>
                <div className="form-group">
                  <label>Subject *</label>
                  <select required defaultValue="">
                    <option value="" disabled>Select a subject</option>
                    <option>Prayer Request</option>
                    <option>Church Partnership</option>
                    <option>Ministry Licensing</option>
                    <option>Donation Inquiry</option>
                    <option>General Inquiry</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Message *</label>
                  <textarea placeholder="Tell us how we can help..." rows={5} required />
                </div>
                <button type="submit" className="btn-primary-gold contact-submit">
                  Send Message →
                </button>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* Map placeholder */}
      <section className="map-section">
        <div className="map-placeholder">
          <div className="map-overlay-text">
            <p>📍</p>
            <h3>2240 Kipling Avenue, Toronto, Canada</h3>
            <p style={{ fontSize: '0.9rem', color: '#666' }}>
              <a
                href="https://maps.google.com/?q=2240+Kipling+Avenue+Toronto+Canada"
                target="_blank"
                rel="noreferrer"
                className="btn-primary-gold"
                style={{ marginTop: '1rem', display: 'inline-block' }}
              >
                Open in Google Maps
              </a>
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
